module.exports = __webpack_public_path__ + "static/media/font_bold.89266734.woff";